// Guide §3 "ID": UUIDv7 (time-ordered) generated on the device; server-derived records use UUIDv5(opId, n)
// so the same operation arriving twice yields the same IDs (Guide §10.1 rule 3).
import { v5 as uuidv5, v7 as uuidv7, validate as uuidValidate } from 'uuid';

export const newId = (): string => uuidv7();

/** Deterministic child ID: UUIDv5(`${opId}:${n}`, namespace = opId). opId must itself be a UUID. */
export const derivedId = (opId: string, n: number): string => uuidv5(`${opId}:${n}`, opId);

export const isUuid = (v: unknown): v is string => typeof v === 'string' && uuidValidate(v);

const BASE62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

/**
 * Invoice link token (Guide §11.7): 128 random bits → base62, always 22 chars.
 * Works in browsers and Node (WebCrypto).
 */
export function newLinkToken(): string {
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  let n = 0n;
  for (const b of bytes) n = (n << 8n) | BigInt(b);
  let out = '';
  while (out.length < 22) {
    out = BASE62[Number(n % 62n)] + out;
    n /= 62n;
  }
  return out;
}

export const LINK_TOKEN_RE = /^[0-9A-Za-z]{22}$/;
export const isLinkToken = (v: unknown): v is string => typeof v === 'string' && LINK_TOKEN_RE.test(v);

/** Fixed namespace for ids that must be identical in every environment (seed data, system rows). */
export const SYSTEM_NAMESPACE = '6f1c1d5e-3b7a-5c21-9d0e-0d0c5a1e0001';
export const stableId = (name: string): string => uuidv5(name, SYSTEM_NAMESPACE);
